const BackIcon = () => {
  return (
    <svg
      className="btn_back_icon"
      width="7"
      height="12"
      viewBox="0 0 7 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M6 11L2 6L6 1" stroke="#4747EB" strokeWidth="2" strokeLinecap="round" />
    </svg>
  )
}

export default BackIcon
